import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_lovers-collective/artifacts/1mezz71g_Arlia%20and%20Tara%20%281%29.png";

const PRINCIPLES = [
  "A Unified platform where all lovers exist in one directory, never segmented by identity.",
  "Self-identification first because lovers describe themselves best in their own words.",
  "Optional identity data, which means that every demographic field is skippable, always.",
  "No hierarchies and no ranking, scoring or prioritisation based on identity.",
  "Collaboration-focused that leads to real-world creative work, not passive listings.",
];

export default function About() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <p className="lif-overline mb-5">Why We Exist</p>
        <h1 className="text-5xl md:text-7xl text-black leading-[0.98] mb-12"
            style={{ fontFamily: '"Bringbold", Georgia, serif' }}>
          The wedding industry has a representation problem.<br/>
          We're here to change that.
        </h1>

        <div className="rounded-[1.5rem] overflow-hidden aspect-square mb-12 border-2 border-black">
          <img src={HERO_IMG} alt="Arlia and Tara" className="w-full h-full object-cover"/>
        </div>

        <div className="prose prose-lg max-w-none text-black/90 leading-relaxed space-y-6">
          <p>
            Styled shoots fill Instagram and blogs, Pinterest boards and portfolios - but if we're being
            honest, they're still showing the exact same narrow version of love over and over again.
          </p>
          <p className="text-2xl text-black"
             style={{ fontFamily: '"Bringbold", Georgia, serif' }}>
            Love, In Full exists to change what gets seen.
          </p>
          <p>
            A platform where wedding pros can discover and collaborate with real, diverse lovers - not
            models (although sometimes they are), not stand-ins, but real people whose love stories
            deserve to be represented authentically and honestly.
          </p>
          <p>
            Built alongside <a className="lif-link" href="https://dancingwithher.com" target="_blank" rel="noreferrer">Dancing With Her</a> and
            {" "}<a className="lif-link" href="https://dancingwiththem.com" target="_blank" rel="noreferrer">Dancing With Them</a> - this is the
            platform behind a more honest visual culture. One where styled edits include real love.
            One where all humans can see themselves in wedding media.
          </p>
          <p>
            Because, you can't be, what you can't see. And, everyone deserves to be seen.
          </p>

          <h3 className="text-3xl text-black !mt-14 !mb-4"
              style={{ fontFamily: '"Bringbold", Georgia, serif' }}>
            What we believe in
          </h3>
          <ul className="!list-none !pl-0 space-y-3">
            {PRINCIPLES.map((s) => (
              <li key={s} className="flex items-start gap-3">
                <span className="mt-1 w-5 h-5 rounded-full bg-mustard/60 border-2 border-black flex items-center justify-center shrink-0">
                  <Heart className="w-3 h-3 text-black" strokeWidth={2.5}/>
                </span>
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-16 p-9 md:p-12 rounded-[1.5rem] bg-lilac border-2 border-black">
          <p className="lif-overline mb-4">Join Love, in Full</p>
          <h2 className="text-3xl md:text-5xl text-black mb-5"
              style={{ fontFamily: '"Bringbold", Georgia, serif' }}>
            and help shape the wedding industry into one that celebrates all love.
          </h2>
          <p className="text-black/90 mb-8 max-w-2xl leading-relaxed">
            Because we're sick of the current mould of what a wedding could or should look like, and we
            know that we can make it more representative of what lovers really look like out in the world.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/join?role=couple" className="lif-btn-cream">Add my listing</Link>
            <Link to="/join?role=vendor" className="lif-btn-powder">I'm a wedding vendor</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
